import PropTypes from 'prop-types';
import AddressPropType from './address';
import ContactPropType from './contact';

const patient = PropTypes.shape({
  id: PropTypes.string,
  pasNumber: PropTypes.string,
  nhsNumber: PropTypes.string,
  title: PropTypes.string,
  forename: PropTypes.string,
  surname: PropTypes.string,
  gender: PropTypes.string,
  dateOfBirth: PropTypes.string,
  dateOfDeath: PropTypes.string,
  gpPractice: PropTypes.string,
  practiceCode: PropTypes.string,
  address: AddressPropType,
  contact: ContactPropType,
  version: PropTypes.number,
});

export default patient;
